module.exports = __webpack_public_path__ + "media/crypto/btc-318a3d31.png";